import Link from 'next/link'
import React from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'

import { useFormatMessage } from '../../hooks'
import appStore from '../../public/images/download-app-store.svg'
import googlePlay from '../../public/images/download-google-play.svg'
import { getCDNSrc } from '../../utils'
import { AppStoreButtonProps } from './AppStoreButton.props'

const AppStoreButton = ({ href, store }: AppStoreButtonProps) => {
  const formatMessage = useFormatMessage()
  return (
    <Link
      href={href}
      target="_blank"
      {...buildActionAnalyticsAttributes(`footer-${store}-tap`)}
    >
      <img
        src={getCDNSrc(store === 'app-store' ? appStore : googlePlay)}
        alt={
          store === 'app-store'
            ? formatMessage('app-store-button.ios.alt')
            : formatMessage('app-store-button.android.alt')
        }
        height={40}
      />
    </Link>
  )
}

export default AppStoreButton
